import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import LandingPage from "@/pages/LandingPage";
import PrivacyPolicy from "@/pages/legal/PrivacyPolicy";
import TermsOfService from "@/pages/legal/TermsOfService";
import Contact from "@/pages/legal/Contact";
import Dashboard from "@/pages/Dashboard";
import ModulePage from "@/pages/ModulePage";
import UserManagement from "@/pages/UserManagement";
import ProductBrain from "@/pages/ProductBrain";
import CustomerBrain from "@/pages/CustomerBrain";
import SupplierBrain from "@/pages/SupplierBrain";
import InventoryIntelligence from "@/pages/InventoryIntelligence";
import SalesHub from "@/pages/SalesHub";
import Procurement from "@/pages/Procurement";
import WarehouseHub from "@/pages/WarehouseHub";
import AuditLogs from "@/pages/AuditLogs";
import YugBrain from "@/pages/YugBrain";
import FinanceHub from "@/pages/FinanceHub";
import BusinessIntelligence from "@/pages/BusinessIntelligence";
import { Billing, InvoicePrint } from "@/pages/Billing";
import {
    SettingsShell,
    SettingsIndex,
    SettingsProfile,
    SettingsAppearance,
    SettingsSecurity,
    SettingsSessions,
    SettingsNotifications,
    SettingsIntegrations,
    SettingsAbout,
} from "@/pages/Settings";

const MODULE_ROUTES = ["help"];

export default function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <Routes>
                        {/* Public */}
                        <Route path="/" element={<LandingPage />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/forgot-password" element={<ForgotPassword />} />
                        <Route path="/privacy" element={<PrivacyPolicy />} />
                        <Route path="/terms" element={<TermsOfService />} />
                        <Route path="/contact" element={<Contact />} />

                        {/* Protected application shell — everything under /app */}
                        <Route
                            path="/app"
                            element={
                                <ProtectedRoute>
                                    <AppLayout />
                                </ProtectedRoute>
                            }
                        >
                            <Route index element={<Navigate to="/app/dashboard" replace />} />
                            <Route path="dashboard" element={<Dashboard />} />
                            <Route path="product-brain" element={<ProductBrain />} />
                            <Route path="customer-brain" element={<CustomerBrain />} />
                            <Route path="supplier-brain" element={<SupplierBrain />} />
                            <Route path="inventory-intelligence" element={<InventoryIntelligence />} />
                            <Route path="sales-hub" element={<SalesHub />} />
                            <Route path="billing" element={<Billing />} />
                            <Route path="billing/:id/print" element={<InvoicePrint />} />
                            <Route path="procurement" element={<Procurement />} />
                            <Route path="warehouse-hub" element={<WarehouseHub />} />
                            <Route path="finance-hub" element={<FinanceHub />} />
                            <Route path="business-intelligence" element={<BusinessIntelligence />} />
                            <Route path="reports" element={<Navigate to="/app/business-intelligence" replace />} />
                            <Route path="audit-logs" element={<AuditLogs />} />
                            <Route path="yug-brain" element={<YugBrain />} />
                            <Route path="user-management" element={<UserManagement />} />
                            <Route path="settings" element={<SettingsShell />}>
                                <Route index element={<SettingsIndex />} />
                                <Route path="profile" element={<SettingsProfile />} />
                                <Route path="appearance" element={<SettingsAppearance />} />
                                <Route path="security" element={<SettingsSecurity />} />
                                <Route path="sessions" element={<SettingsSessions />} />
                                <Route path="notifications" element={<SettingsNotifications />} />
                                <Route path="integrations" element={<SettingsIntegrations />} />
                                <Route path="about" element={<SettingsAbout />} />
                            </Route>
                            {MODULE_ROUTES.map((path) => (
                                <Route key={path} path={path} element={<ModulePage />} />
                            ))}
                            <Route path="*" element={<Navigate to="/app/dashboard" replace />} />
                        </Route>

                        {/* Anything else → landing */}
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}
